import React from "react";
import { GoogleMap, Marker, Circle, useJsApiLoader } from "@react-google-maps/api";

const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const containerStyle = { width: "100%", height: "320px", borderRadius: 8 };
const DEFAULT_CENTER = { lat: 20.5937, lng: 78.9629 }; // India, used only when no point is set yet

// Click-to-place / drag-to-adjust geofence picker: a marker at (lat,lng) plus
// a circle showing the tolerance radius, both editable directly on the map.
// Renders nothing (returns null) when no API key is configured — callers
// keep their plain lat/lng/radius number inputs as the fallback either way,
// so Workplace Config still works without a Maps key, just without the map.
const GeofenceMapPicker = ({ lat, lng, radiusMeters, onChange }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "sattis-google-map-script",
    googleMapsApiKey: MAPS_API_KEY,
  });
  if (!MAPS_API_KEY) return null;
  if (loadError) {
    return (
      <div className="alert alert-warning py-2 px-3 mb-3">
        Could not load Google Maps — check the API key.
      </div>
    );
  }
  if (!isLoaded) {
    return (
      <div className="border rounded d-flex align-items-center justify-content-center text-muted mb-3" style={{ height: 320 }}>
        Loading map…
      </div>
    );
  }

  const hasPoint = Number.isFinite(lat) && Number.isFinite(lng);
  const center = hasPoint ? { lat, lng } : DEFAULT_CENTER;

  const placeAt = (latLng) => {
    onChange({ lat: latLng.lat(), lng: latLng.lng() });
  };

  return (
    <div className="mb-3">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={hasPoint ? 16 : 5}
        onClick={(e) => placeAt(e.latLng)}
        options={{ streetViewControl: false, mapTypeControl: false }}
      >
        {hasPoint && (
          <>
            <Marker
              position={center}
              draggable
              onDragEnd={(e) => placeAt(e.latLng)}
            />
            <Circle
              center={center}
              radius={Number(radiusMeters) || 50}
              options={{
                fillColor: "#4f46e5",
                fillOpacity: 0.12,
                strokeColor: "#4f46e5",
                strokeOpacity: 0.6,
                strokeWeight: 1,
              }}
            />
          </>
        )}
      </GoogleMap>
      <div className="form-text">
        {hasPoint
          ? "Click elsewhere on the map, or drag the pin, to move the site. The shaded circle is the tolerance radius."
          : "Click on the map to place the site — or use “Use My Location” below."}
      </div>
    </div>
  );
};

export default GeofenceMapPicker;
